import Header from 'components/RecurringOrderSuggestionsDiscardReasonsModal/Sections/Header/styled';

export default Header;
